// src/App.js
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom'; // Importe o BrowserRouter
import { ThemeProvider } from 'styled-components';
import { Spin } from 'antd';

import './config/yupConfig';
import './config/i18n';
import './config/reactotronConfig';
import 'styles/override.scss';
import theme from 'styles/theme';

import GlobalStyles from './styles/global';
import Routes from './routes';

function App() {
  return (
    <Suspense fallback={<Spin className="page-loader" />}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {/* Encapsule os Routes com BrowserRouter */}
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
